import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import ApprovalDetailDrawer from "../../../components/ApprovalDetailsDrawer";
import DrawerScreens from "../DrawerScreens";
import Profile from "../../../screens/Profile";
import { usePusher } from "../../../../private/offers/infrastructure/ui/hooks";
import { Header } from "../../../../private/layout/infrastructure/ui/components/header";


const PrivateStack = createStackNavigator();



const PrivateScreens: React.FC = () => {
  usePusher();

  return (
  <PrivateStack.Navigator  headerMode="float" screenOptions={{header:() => <Header />, headerStyle:{marginBottom: 30}}}>
    <PrivateStack.Screen name="main" component={DrawerScreens}  />
    <PrivateStack.Screen name="profile" component={Profile} options={{ title: "Carrier Approvals - Profile"}} />
  </PrivateStack.Navigator>
)};

export default PrivateScreens;
